import * as Yup from "yup";

export const validation = Yup.object().shape({
    desde: Yup.string().required("Requerido"),
    hasta: Yup.string().required("Requerido"),
});